// usePrimaryOrgId — returns the org_id the signed-in user belongs to.
// Uses get_my_effective_org_id() RPC which:
//   1. Returns the user's most recent active organization_members row, OR
//   2. Falls back to the management organization for HIBANE staff
//      (admin / super_admin).
// Returns null when not signed in or when no membership can be resolved.
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function usePrimaryOrgId() {
  return useQuery<string | null>({
    queryKey: ["primary-org-id"],
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const { data: u } = await supabase.auth.getUser();
      if (!u?.user) return null;
      const { data, error } = await supabase.rpc("get_my_effective_org_id");
      if (error || !data) return null;
      return data as string;
    },
  });
}
